import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Observable } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@core/animations/route.animations';
import { NgModule } from '@angular/core';

@Component({
  selector: 'app-under-construction-page',
  template: `
  <div class="under-construction-page" fxLayout="column" fxFill fxLayoutAlign="center center">
    <mat-card [ngClass]="routeAnimationsElements" [ngClass]="{'full-width': isMobileMode$ | async, 'half-width': (isMobileMode$ | async) === false}" [class.mat-elevation-z24]="'true'">
      <app-under-construction [theme]="theme$ | async"></app-under-construction>
    </mat-card>
  </div>
  `,
  styles: [
    `
      .under-construction-page {
        background: url(/assets/background-1.jpg) no-repeat center center fixed;
        background-size: cover;
        padding: 32px;
      }

      .full-width {
        width: 100%;
      }

      .half-width {
        width: 30%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderConstructionPageComponent implements OnInit {
  @Select(UiState.getTheme) theme$: Observable<string>;
  @Select(UiState.getIsMobileMode) isMobileMode$: Observable<boolean>;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
  }
}
